const isTankInfoIncomplete = (values: {
  isTankInfoEnabled: boolean;
  tankCount?: number;
  tankSize?: number;
  overallRatePerAcre?: number;
  totalProduct?: number;
  isCarrierRowHidden: boolean;
  products?: any[];
}) => {
  if (!values.isTankInfoEnabled) return false;

  return (
    values.tankCount === undefined ||
    values.tankSize === undefined ||
    values.overallRatePerAcre === undefined ||
    values.totalProduct === undefined ||
    (values.products?.length === 1 && values.isCarrierRowHidden)
  );
};

export default isTankInfoIncomplete;
